import React from "react";

interface PlusIconProps {
  className?: string;
  size?: number;
  /** Match the stroke to the border of the control it sits in. */
  strokeWidth?: number;
}

/**
 * Bare plus stroke — no enclosing circle, inherits colour from the parent.
 * CirclePlusIcon is the outlined variant used on light surfaces; this one is
 * for filled buttons where the circle would fight the button's own shape.
 */
export const PlusIcon = ({
  className = "",
  size = 16,
  strokeWidth = 1.8,
}: PlusIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 3.25V12.75M3.25 8H12.75"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);
